import PropTypes, { instanceOf } from 'prop-types'

export const metaRobotsNoIndex = {
  name: 'robots',
  content: 'noindex',
}

export function filterProducts(originalProducts, idsToFilter) {
  if (idsToFilter && originalProducts instanceof Array) return originalProducts.filter(product => !idsToFilter.some(idToFilter => product.id == idToFilter.id))
  else if (idsToFilter && !(originalProducts instanceof Array)) {
    const singleProduct = new Array(originalProducts)
    return singleProduct.filter(product => !idsToFilter.some(idToFilter => product?.id == idToFilter.id))
  } else return originalProducts
}

filterProducts.propTypes = {
  originalProducts: PropTypes.object.isRequired,
  idsToFilter: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })),
}
